import { render, staticRenderFns } from "./InactiveMemberShip.vue?vue&type=template&id=f285b5f8&scoped=true&"
import script from "./InactiveMemberShip.ts?vue&type=script&lang=ts&"
export * from "./InactiveMemberShip.ts?vue&type=script&lang=ts&"
import style0 from "./InactiveMemberShip.vue?vue&type=style&index=0&id=f285b5f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f285b5f8",
  null
  
)

export default component.exports